import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "col-sm-12" }
const _hoisted_2 = { class: "card card-body" }
const _hoisted_3 = { class: "overflow-auto" }
const _hoisted_4 = { class: "table table-striped border-light align-middle text-left text-nowrap position-relative" }
const _hoisted_5 = { class: "text-capitalize-first" }
const _hoisted_6 = { class: "text-capitalize-first" }
const _hoisted_7 = { class: "text-capitalize-first" }
const _hoisted_8 = { class: "text-capitalize-first" }
const _hoisted_9 = { class: "text-capitalize-first" }
const _hoisted_10 = { class: "text-capitalize-first" }
const _hoisted_11 = ["title"]
const _hoisted_12 = { class: "text-end" }
const _hoisted_13 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_copy_button = _resolveComponent("copy-button")!
  const _component_b_pagination = _resolveComponent("b-pagination")!
  const _component_AccountOperations = _resolveComponent("AccountOperations")!
  const _component_LoaderWrapper = _resolveComponent("LoaderWrapper")!
  const _directive_b_tooltip = _resolveDirective("b-tooltip")!

  return (_openBlock(), _createBlock(_component_LoaderWrapper, {
    ref: "loader",
    class: "h-100"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("table", _hoisted_4, [
              _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", _hoisted_5, _toDisplayString(_ctx.helper.trans('labels.id')), 1),
                  _createElementVNode("th", _hoisted_6, _toDisplayString(_ctx.helper.trans('labels.merchant')), 1),
                  _createElementVNode("th", _hoisted_7, _toDisplayString(_ctx.helper.trans('labels.store')), 1),
                  _createElementVNode("th", _hoisted_8, _toDisplayString(_ctx.helper.trans('labels.currency')), 1),
                  _createElementVNode("th", _hoisted_9, _toDisplayString(_ctx.helper.trans('labels.sum')), 1),
                  _createElementVNode("th", _hoisted_10, _toDisplayString(_ctx.helper.trans('dashboard.on_hold')), 1),
                  _cache[3] || (_cache[3] = _createElementVNode("th", null, null, -1))
                ])
              ]),
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.accountItems, (storeAccount) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: storeAccount.account.id,
                    class: ""
                  }, [
                    _createElementVNode("td", null, [
                      _withDirectives((_openBlock(), _createElementBlock("span", {
                        title: storeAccount.account.id
                      }, [
                        _createTextVNode(_toDisplayString(storeAccount.account.id.substring(0, 8)) + "...", 1)
                      ], 8, _hoisted_11)), [
                        [
                          _directive_b_tooltip,
                          void 0,
                          void 0,
                          { hover: true }
                        ]
                      ]),
                      _cache[4] || (_cache[4] = _createTextVNode()),
                      _createVNode(_component_copy_button, {
                        value: storeAccount.account.id
                      }, null, 8, ["value"])
                    ]),
                    _createElementVNode("td", null, _toDisplayString(storeAccount.merchantEmail), 1),
                    _createElementVNode("td", null, _toDisplayString(storeAccount.storeName), 1),
                    _createElementVNode("td", null, _toDisplayString(storeAccount.account.currency), 1),
                    _createElementVNode("td", null, _toDisplayString(_ctx.numberFormatter.formatNumber(storeAccount.account.sum)), 1),
                    _createElementVNode("td", null, _toDisplayString(_ctx.numberFormatter.formatNumber(storeAccount.account.frozenSum)), 1),
                    _createElementVNode("td", _hoisted_12, [
                      (_ctx.accountForDetails !== null)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            type: "button",
                            onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.accountForDetails = null), ["prevent"])),
                            class: "btn btn-sm btn-outline-dark text-nowrap text-capitalize"
                          }, [
                            _cache[5] || (_cache[5] = _createElementVNode("i", { class: "fa fa-arrow-left" }, null, -1)),
                            _createTextVNode(" " + _toDisplayString(_ctx.helper.trans('button.back')), 1)
                          ]))
                        : (_openBlock(), _createElementBlock("button", {
                            key: 1,
                            onClick: _withModifiers(($event: any) => (_ctx.accountForDetails = storeAccount), ["prevent"]),
                            class: "btn btn-sm btn-outline-dark text-nowrap text-capitalize-first"
                          }, _toDisplayString(_ctx.helper.trans("menu.items.accountOperations")), 9, _hoisted_13))
                    ])
                  ]))
                }), 128))
              ])
            ]),
            (_ctx.accounts.totalCount > _ctx.accounts.items.length)
              ? (_openBlock(), _createBlock(_component_b_pagination, {
                  key: 0,
                  modelValue: _ctx.page,
                  "onUpdate:modelValue": [
                    _cache[1] || (_cache[1] = ($event: any) => ((_ctx.page) = $event)),
                    _cache[2] || (_cache[2] = ($event: any) => (_ctx.loadAccounts()))
                  ],
                  "total-rows": _ctx.accounts.totalCount,
                  "per-page": _ctx.accounts.limit,
                  limit: 20,
                  "prev-text": "Back",
                  "next-text": "Next",
                  align: "start",
                  "first-number": "",
                  "hide-goto-end-buttons": "",
                  "hide-ellipsis": ""
                }, null, 8, ["modelValue", "total-rows", "per-page"]))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      (_ctx.accountForDetails)
        ? (_openBlock(), _createBlock(_component_AccountOperations, {
            key: 0,
            account: _ctx.accountForDetails.account,
            class: _normalizeClass('m-0')
          }, null, 8, ["account"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 512))
}